<template>
  <a-card class="m-t-10 m-b-20" :bordered="false" v-if="statics.activity_info">
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      <span class="s_c000 s_font_b fz-16 m-l-10">活动名称：{{statics.activity_info.activity_name}}</span> 
      <div class="head s_flex_ali s_ceee m-t-20">
        活动ID：{{statics.activity_info.activity_id}}
        <span class="m-r-30 m-l-30">活动状态：{{statics.activity_info.status_title}} </span>时间进度：
        <a-progress :percent="statics.activity_info.plan" status="active" class="width-200" />
      </div>
  </a-card>
  <div style="background: #ececec; padding: 24px" class="s_flex_ali" v-if="statics.activity_info">
    <a-card title="扫码量" class="flex_1 m-r-10">
      <template #extra>
        <a-tooltip placement='right'>
          <template #title>统计包括首次、重复扫码数量。
          </template>
          <QuestionCircleOutlined />
        </a-tooltip>
      </template>
      <p class="m-b-5">
        <a-tag color="green">昨日</a-tag>{{statics.scan_statistics.yesterday}}
      </p>
      <p class="m-b-5">
        <a-tag color="orange">今日</a-tag>{{statics.scan_statistics.today}}
      </p>
      <p>
        <a-tag color="red">总计</a-tag>{{statics.scan_statistics.total}}
      </p>
    </a-card>

    <a-card title="活动参与量" class="flex_1 m-r-10">
      <template #extra>
        <a-tooltip placement='right'>
          <template #title>统计该活动所有码的领奖记录条数,包括中奖、未中奖
          </template>
          <QuestionCircleOutlined />
        </a-tooltip>
      </template>
      <p class="m-b-5">
        <a-tag color="green">昨日</a-tag>{{statics.scan_act_statistics.yesterday}}
      </p>
      <p class="m-b-5">
        <a-tag color="orange">今日</a-tag>{{statics.scan_act_statistics.today}}
      </p>
      <p>
        <a-tag color="red">总计</a-tag>{{statics.scan_act_statistics.total}}
      </p>
    </a-card>

    <a-card title="活动参与人数" class="flex_1 m-r-10">
      <template #extra>
        <a-tooltip placement='right'>
          <template #title>统计活动总参与人数，多次参与只算一次。
          </template>
          <QuestionCircleOutlined />
        </a-tooltip>
      </template>
      <p class="m-b-5">
        <a-tag color="green">昨日</a-tag>{{statics.scan_user_statistics.yesterday}}
      </p>
      <p class="m-b-5">
        <a-tag color="orange">今日</a-tag>{{statics.scan_user_statistics.today}}
      </p>
      <p>
        <a-tag color="red">总计</a-tag>{{statics.scan_user_statistics.total}}
      </p>
    </a-card>
    <a-card title="活动中奖人数" class="flex_1 m-r-10">
      <template #extra>
        <a-tooltip placement='right'>
          <template #title>统计活动总参与人数，多次参与只算一次。
          </template>
          <QuestionCircleOutlined />
        </a-tooltip>
      </template>
      <p class="m-b-5">
        <a-tag color="green">昨日</a-tag>{{statics.scan_user_award_statistics.yesterday}}
      </p>
      <p class="m-b-5">
        <a-tag color="orange">今日</a-tag>{{statics.scan_user_award_statistics.today}}
      </p>
      <p>
        <a-tag color="red">总计</a-tag>{{statics.scan_user_award_statistics.total}}
      </p>
    </a-card>
    <a-card title="奖项发放数量" class="flex_1 ">
      <template #extra>
        <a-tooltip placement='right'>
          <template #title>统计活动总参与人数，多次参与只算一次。
          </template>
          <QuestionCircleOutlined />
        </a-tooltip>
      </template>
      <p class="m-b-5">
        <a-tag color="green">昨日</a-tag>{{statics.scan_award_statistics.yesterday}}
      </p>
      <p class="m-b-5">
        <a-tag color="orange">今日</a-tag>{{statics.scan_award_statistics.today}}
      </p>
      <p>
        <a-tag color="red">总计</a-tag>{{statics.scan_award_statistics.total}}
      </p>
    </a-card>
  </div>
  <a-row :gutter="16" class="m-t-20 ">
    <a-col :span="12">
      <a-card :bordered="false">
        <a-radio-group v-model:value="rate" button-style="solid">
          <a-radio-button value="activity">活动参与率 <a-tooltip placement='right'>
              <template #title>活动参与量/扫码个数*100%，如活动参与量为5，扫码个数为10，则活动参与率为50%。
              </template>
              <QuestionCircleOutlined class="m-l-5" />
            </a-tooltip>
          </a-radio-button>
          <a-radio-button value="replace" v-if="$route.query.activity_type!=2">重复购买率<a-tooltip placement='right'>
              <template #title>活动重复参与人数/活动总参与人数*100%，如共有10个客户购买了产品，5个产生了重复购买，则重复购买率为50%。
              </template>
              <QuestionCircleOutlined class="m-l-5" />
            </a-tooltip>
          </a-radio-button>
        </a-radio-group>
        <div class="s_flex_center m-t-100 m-b-100">
          <a-progress type="circle" :format="percent => `${percent}%`" :percent="rate=='activity'?statics.act_participation_rate:statics.user_repurchase_rate" />
        </div>
        <!-- <pie  /> -->
      </a-card>
    </a-col>
    <a-col :span="12">
      <div class="s_bf  p-5">
        <div class="s_flex_ali dataPanel p-10 m-b-60" v-if="$route.query.activity_type!=2">
          <div v-for='item in dataPanelList' :key='item'>
            <div class=" bor-rad-10  s_po_re  p-t-20 p-b-20 s_bf m-r-10 m-l-10" :class="{disabled:item.disabled,active:item.key==active}" @click="selectTab(item)">
              <img class="width-60 height-60 s_dis_b s_mauto" :src="item.icon_url" alt="">
              <p class="s_c999 text-ac">{{item.name}}</p>
            </div>
          </div>
        </div>
        <div class="s_flex_ali dataPanel s_bf58 p-10 m-b-60" v-else>
          <div>
            <div class=" bor-rad-10  s_po_re  p-t-20 p-b-20 s_bf m-r-10 m-l-10">
              <img class="width-60 height-60 s_dis_b s_mauto" src="@/assets/images/scan/cardIcon.png" alt="">
              <p class="s_c999 text-ac">会员卡发放监控</p>
            </div>
          </div>
        </div>
        <!-- 会员卡 -->
        <a-card :bordered="false" class="m-b-75" v-if="$route.query.activity_type==2">
          <a-row>
            <a-col :span="12">
              <a-statistic title="数据发放总量" :value="statics.scan_award_statistics.total" style="margin-right: 50px" />
            </a-col>
          </a-row>
        </a-card>
        <div v-else>
          <!-- 红包 -->
          <a-card :bordered="false" class="m-b-75" v-if="statics.act_award_statistics&&active=='red'">
            <a-row>
              <a-col :span="12">
                <a-statistic title="数据发放总量" :value="statics.act_award_statistics.bonus_num" style="margin-right: 50px" />
              </a-col>
              <a-col :span="12">
                <a-statistic title="红包发放失败总量" :precision="2" :value="statics.act_award_statistics.bonus_num_fail" />
              </a-col>
            </a-row>
          </a-card>
          <!-- 积分 -->
          <a-card :bordered="false" class="m-b-75" v-if="statics.act_award_statistics&&active=='jifen'">
            <a-row>
              <a-col :span="12">
                <a-statistic title="数据发放总量" :value="statics.act_award_statistics.point_num" style="margin-right: 50px" />
              </a-col>
              <a-col :span="12">
                <a-statistic title="积分发放失败总量" :precision="2" :value="statics.act_award_statistics.point_num_fail" />
              </a-col>
            </a-row>
          </a-card>
          <!-- 礼品 -->
          <a-card :bordered="false" class="m-b-75" v-if="statics.act_award_statistics&&active=='lipinfei'">
            <a-row>
              <a-col :span="12">
                <a-statistic title="数据发放总量" :value="statics.act_award_statistics.gift_num" style="margin-right: 50px" />
              </a-col>
              <a-col :span="12">
                <a-statistic title="礼品发放失败总量" :precision="2" :value="statics.act_award_statistics.point_num_fail" />
              </a-col>
            </a-row>
          </a-card>
        </div>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import { LeftOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { activitysStatics } from "@/api/qrcodeActivitys";
import { reactive, toRefs } from "@vue/reactivity";
import store from "@/store";
import { inject, onMounted } from "@vue/runtime-core";
import { iscode } from "../../../../utils/app";
const dataPanelList = [
  {
    icon_url: require("@/assets/images/scan/hongbao.png"),
    name: "红包发放监控",
    key: "red",
    disabled: false,
  },
  {
    icon_url: require("@/assets/images/scan/jifen.png"),
    name: "积分发放监控",
    key: "jifen",
    disabled: false,
  },
  {
    icon_url: require("@/assets/images/scan/wodekaquan.png"),
    name: "优惠券监控",
    key: "wodekaquan",
    disabled: true,
  },
  {
    icon_url: require("@/assets/images/scan/lipinfei.png"),
    name: "礼品发放监控",
    key: "lipinfei",
    disabled: false,
  },
  {
    icon_url: require("@/assets/images/scan/dazhuanpan.png"),
    name: "大转盘监控",
    key: "dazhuanpan",
    disabled: true,
  },
];

export default {
  components: { QuestionCircleOutlined, LeftOutlined },
  setup() {
    const state = reactive({
      rate: "activity",
      active: "red",
      statics: {},
    });
    // 点击数据面板
    const selectTab = (item) => {
      if (item.disabled) return;
      state.active = item.key;
    };
    const $route = inject("$route");
    const getData = async () => {
      let result = await activitysStatics($route.query.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        state.statics = result.data;
      }
    };
    onMounted(() => {
      getData();
    });
    return {
      ...toRefs(state),
      dataPanelList,
      info: store.state.user.info,
      selectTab,
    };
  },
};
</script>

<style lang="less" scoped>
.dataPanel {
  display: flex;
  flex-wrap: wrap;
  > div {
    width: 20%;
    cursor: pointer;
    transition: all 0.3s;
    > div {
      &:hover {
        box-shadow: 7px 5px 22px 0px #9cb9d7;
      }
    }
    .active {
      border: 1px solid #bbddff;
      box-shadow: 7px 5px 22px 0px #9cb9d7;
      position: relative;
      left: -5px;
      top: -5px;
    }
    .disabled {
      -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
      filter: grayscale(100%);
      cursor: not-allowed;
      &:hover {
        box-shadow: none;
      }
    }
  }
}
</style>